import { CompetitionRanking, ICompetitionRanking } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { TeamRankingQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<TeamRankingQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<TeamRankingQuery>): ICompetitionRanking => {
  return transformer(props);
}

const TeamRankingWidget = ({
  props,
  ...rest
}: WidgetContext<ICompetitionRanking>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <CompetitionRanking {...props} />
    </div>
  );
}

export default TeamRankingWidget;